import { useEffect, useState } from 'react';

/* ────────────────────────────────────────────────────────────
 * useChartTheme — read the chart palette tokens off the live
 * :root computed styles so Recharts inherits the design tokens
 * (light / dark mode flip without a prop change).
 *
 * Re-reads when the data-theme attribute on <html> changes so a
 * theme toggle reflows the chart without a full re-mount.
 * ──────────────────────────────────────────────────────────── */

const TOKEN_NAMES = {
  series: ['--chart-1', '--chart-2', '--chart-3', '--chart-4', '--chart-5', '--chart-6', '--chart-7', '--chart-8'],
  grid: '--chart-grid',
  axis: '--chart-axis',
  tooltipBg: '--chart-tooltip-bg',
  tooltipFg: '--chart-tooltip-fg',
};

const readPalette = () => {
  if (typeof window === 'undefined' || !window.getComputedStyle) {
    return {
      series: ['#53B7E8', '#3DA298', '#6366F1', '#F59E0B', '#EC4899', '#10B981', '#8B5CF6', '#EF4444'],
      grid: 'rgba(15, 23, 42, 0.06)',
      axis: '#64748B',
      tooltipBg: '#0F172A',
      tooltipFg: '#F1F5F9',
    };
  }
  const style = window.getComputedStyle(document.documentElement);
  const read = (name) => style.getPropertyValue(name).trim();
  return {
    series: TOKEN_NAMES.series.map(read).filter(Boolean),
    grid: read(TOKEN_NAMES.grid),
    axis: read(TOKEN_NAMES.axis),
    tooltipBg: read(TOKEN_NAMES.tooltipBg),
    tooltipFg: read(TOKEN_NAMES.tooltipFg),
  };
};

const useChartTheme = () => {
  const [palette, setPalette] = useState(readPalette);

  useEffect(() => {
    if (typeof MutationObserver === 'undefined') return undefined;
    const observer = new MutationObserver(() => setPalette(readPalette()));
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['data-theme', 'class'] });
    return () => observer.disconnect();
  }, []);

  return palette;
};

export default useChartTheme;
